import { testAccess } from '@/utils/fs/fs-extra.utils';
import { ElectronApi } from '../electron.api';
import { astToXml } from '@/utils/xmlTool';
import { encodeXmlEntities } from '@/utils/ast/utils/xml.utils';

export class WatchfaceManifest {
  private manifestXmlPath: string;

  constructor(manifestXmlPath: string) {
    this.manifestXmlPath = manifestXmlPath;
  }

  /**
   * 写入description文件
   * @param ast 需要写入的ast
   * @returns
   */
  async writeManifestXML(manifestAst: Ast) {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;

    const to = this.manifestXmlPath;
    let str = astToXml(manifestAst ?? {});
    // 转义非法字符
    str = encodeXmlEntities(str);
    await fs.promises.writeFile(to, str, 'utf8');
  }

  async readManifestXML() {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;
    try {
      if ((await testAccess(this.manifestXmlPath)) != true) return;
      return await fs.promises.readFile(this.manifestXmlPath, 'utf8');
    } catch (error) {
      console.log(error);
    }
  }
  async copyManifestXML(newName: string) {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;
    try {
      if ((await testAccess(this.manifestXmlPath)) != true) return;
      await fs.promises.cp(
        this.manifestXmlPath,
        path.join(path.dirname(this.manifestXmlPath), newName),
        {
          force: true
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
}
